export class Bairro {
    Id: string; // No modelo o campo é "IDBairro", utilizando "Id" por limitação do Mock-up
    IdLocalidade: string;
    NomeBairro: string;
}



// WEBPACK FOOTER //
// ./src/app/bairro/bairro.model.ts